// import consts
import { dynamicAssets } from 'js/constants/Paths';

export const parseData = (data) => {
  const videoIds = [];
  const videosById = {};

  if (data && data?.length > 0) {
    data.map((item, index) => {
      if (item.cta_image && item.cta_image !== '') {
        item.imageUrl = dynamicAssets(item.cta_image);
      }

      if (item.file_upload && item.file_upload !== '') {
        item.link = dynamicAssets(item.file_upload, false);
      }

      if (item.video_poster && item.video_poster !== '') {
        item.video_poster = dynamicAssets(item.video_poster);
      }

      if (item.file_upload && item.file_upload !== '') {
        item.file_upload = dynamicAssets(item.file_upload, false);
      }

      item.type = 'video';

      videoIds.push(item.id);
      videosById[item.id] = item;
    });
  }

  return { videosById, videoIds };
};
